import { counterpartyTxnTypeSchema } from "@station/contracts";
import { SkeletonRows } from "@station/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { companySearchShape } from "../../../features/accounting/company.js";
import { todayIstanbul } from "../../../features/accounting/shared.js";
import { useCounterpartyOption } from "../../../features/counterparties/counterparty-combobox.js";
import { CounterpartyPage, useListCrumb } from "../../../features/counterparties/shared.js";
import { TransactionForm } from "../../../features/counterparties/transaction-form.js";

const searchSchema = z.object({
  ...companySearchShape,
  /** Kart detayından gelindiğinde cari ve hareket türü hazır seçilir. */
  counterpartyId: z.string().uuid().optional().catch(undefined),
  type: counterpartyTxnTypeSchema.optional().catch(undefined),
});

export const Route = createFileRoute("/_app/cari/hareket-yeni")({
  validateSearch: (search) => searchSchema.parse(search),
  component: NewTransactionPage,
});

function NewTransactionPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const listCrumb = useListCrumb();
  const search = Route.useSearch();
  const preset = useCounterpartyOption(search.counterpartyId);
  return (
    <CounterpartyPage
      title={t("menu.counterpartyTransaction")}
      description={t("counterparties.txn.description")}
      breadcrumb={[listCrumb, { label: t("menu.counterpartyTransaction") }]}
    >
      {({ companyId }) =>
        preset.isLoading ? (
          <SkeletonRows rows={6} />
        ) : (
          <TransactionForm
            // Ön seçim geç çözülürse form o cariyle yeniden kurulur (ilk değerler bir kez okunur).
            key={preset.option?.id ?? "blank"}
            companyId={companyId}
            initialType={search.type ?? "COLLECTION"}
            initialCounterparty={preset.option}
            today={todayIstanbul()}
            onSaved={(result) =>
              void navigate({
                to: "/cari/$id",
                params: { id: result.counterpartyId },
                search: { tab: "open-items" },
              })
            }
          />
        )
      }
    </CounterpartyPage>
  );
}
